export default __webpack_public_path__ + "static/media/Sinergia_Patrocinios_WGBC.92853b64.jpg";